import { cva, VariantProps } from 'class-variance-authority';

export const colorVariant = cva('', {
  variants: {
    bg: {
      'navy-2': 'bg-emerge-navy-2',
      'navy-3': 'bg-emerge-navy-3',
      'navy-50': 'bg-dark-navy-50'
    },
    text: {
      white: 'text-white',
      'navy-4': 'text-emerge-navy-4'
    },
    border: {
      'navy-3': 'border-emerge-navy-3'
    }
  }
});

export type TColorVariantProps = VariantProps<typeof colorVariant>;
export type TNavBg = 'navy-2' | 'navy-3' | 'navy-50';
